module.exports = __webpack_public_path__ + "static/media/about-img-10@2x.3b8f9df6.png";